import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  Injector,
} from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { BaseComponent } from '@app/shared/base/base-component/base-component.component';
import { AttributeOption, predefinedUOMs } from '@app/shared/interfaces/Attribute';

@Component({
  selector: 'app-attribute-uom',
  templateUrl: './attribute-uom.component.html',
  styleUrls: ['./attribute-uom.component.less'],
})
export class AttributeUomComponent extends BaseComponent implements OnInit {
  @Input() units: AttributeOption[] = [];
  @Input() attributeId: number;
  @Input() formGroup:FormGroup;
  @Input() record:any;
  @Output() onUnitsChange = new EventEmitter<AttributeOption[]>();
  predefinedUnits = Object.keys(predefinedUOMs);
  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {
   this.record=this.units;
    this.initForm();
  }
  initForm() {
    this.formGroup = this.fb.group({
      units: this.fb.array(this.units.map(unit => this.createUnitFormGroup(unit)))
    });
  }
  createUnitFormGroup(unit: AttributeOption): FormGroup {
    return this.fb.group({
      Name: new FormControl(unit.Name),
      Translations: this.fb.array(unit.Translations || [])
    });
  }

  updateFormGroup() {

    const unitsFormArray = this.formGroup.get('units') as FormArray;
    unitsFormArray.clear();
    this.units.forEach(unit => unitsFormArray.push(this.createUnitFormGroup(unit)));
  }

  handleUnitsTranslationChange(updatedUnits: AttributeOption[]): void {
    //
    if(this.formGroup){
    this.formGroup.markAsDirty();
    }else {
      console.error('formGroup is not defined!');
  }
    this.units = updatedUnits;
     this.updateFormGroup(); 
    this.onUnitsChange.emit(this.units);
  }


  // showAddOptionModal = false;
  // optionToAdd = {
  //   Name: '',
  // };
  handleOptionsChange(updatedUnits: AttributeOption[]) {
    
    this.units = [...updatedUnits];
    this.onUnitsChange.emit(this.units);
  }


  addPredefinedUOMs(uom: string) {

    const uoms = predefinedUOMs[uom];
    this.units = [
      ...this.units,
      ...uoms.map((u) => {
        const option: AttributeOption = {
          AttributeId: 0,
          Id: 0,
          IsDefault: false,
          Value: u.Code as string,
          Name: u.Label,
          Translations: []
        };
        return option;
      }),
    ];
    this.onUnitsChange.emit(this.units);
  }



}




    
  // removeUnit(unit: AttributeOption) {
  //   this.units = [...this.units.filter((x) => x.Name !== unit.Name)];
  //   this.onUnitsChange.emit(this.units);
  // }

  // submitUOM() {
  //   if (this.optionToAdd.Name == null || this.optionToAdd.Name == '') {
  //     this.message.error(
  //       this.layoutService.translate(
  //         'please write some text in the UOM name field'
  //       )
  //     );
  //     return;
  //   }
  //   this.units = [
  //     ...this.units,
  //     {
  //       Id: 0,
  //       IsDefault: false,
  //       Name: this.optionToAdd.Name,
  //       Value: this.optionToAdd.Name,
  //       AttributeId: this.attributeId,
  //       Translations: [],
  //     },
  //   ];
  //   this.onUnitsChange.emit(this.units);
  //   this.showAddOptionModal = false;
  //   this.optionToAdd = {
  //     Name: '',
  //   };
  // }

  // cancel() {
  //   this.showAddOptionModal = false;
  //   this.optionToAdd = {
  //     Name: '',
  //   };
  // }

